import { NutritionObjectives } from "@/app/nutrition-wizard/nutrition-objectives";
import { Meal } from "@/app/nutrition/meal.enum";
import { Option } from "@/app/nutrition/option.enum";
import {
  faChevronLeft,
  faChevronRight,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { faArrowsRetweet } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, type FC } from "react";

export type NutritionMealTableTabsProps = {
  counter?: number;
  objective?: NutritionObjectives;
  readonly?: boolean;
  algorithm?: boolean;
  onOptionDelete: (meal: Meal, option: Option) => void;
  onOptionSwap: (meal: Meal, option: Option) => void;
  onOptionRight: (meal: Meal, option: Option) => void;
  onOptionLeft: (meal: Meal, option: Option) => void;
  onShowSuplementation: () => void;
  showSupplementation?: boolean;
  option: Option;
  meal: Meal;
  currentTab: number;
  setCurrentTab: (tab: number) => void;
};

export const NutritionMealTableTabs: FC<NutritionMealTableTabsProps> = ({
  counter,
  readonly,
  algorithm,
  currentTab,
  meal,
  objective,
  option,
  onShowSuplementation,
  showSupplementation,
  setCurrentTab,
  onOptionDelete,
  onOptionSwap,
  onOptionRight,
  onOptionLeft,
}) => {
  return (
    <div className="">
      <div className="flex-1">
        <div className="md:hidden flex items-center gap-4">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          <select
            id="tabs"
            name="tabs"
            value={currentTab}
            onChange={(e) => setCurrentTab(Number(e.target.value))}
            className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-primary focus:outline-none focus:ring-primary sm:text-sm"
          >
            {Object.entries(Option).map(([, option], index) => (
              <option key={`mobile-tab-${option}`} value={index}>
                {option}
              </option>
            ))}
          </select>
          <button className="ml-2">
            <FontAwesomeIcon icon={faArrowsRetweet} className="h-7 w-7" />
          </button>
        </div>

        {/* Mostrar botón debajo de los tabs en pantallas pequeñas */}
        <div className="md:hidden mt-4">Suplementaion</div>

        {/* Tabs para pantallas grandes */}
        <div className="hidden md:flex justify-between items-center border-b border-gray-200">
          {/* Contenedor de los tabs */}
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {Object.entries(Option)
              .filter(([, option]) =>
                algorithm ? true : !option.includes("alt")
              )
              .map(([, option], index) => (
                <div
                  className={`h-14 d-flex items-center flex items-center ${currentTab === index ? "border-b-2 border-primary  text-primary-600" : ""}`}
                  key={`nutrition-meal-table-tab-${index}`}
                >
                  {!readonly && currentTab === index && (
                    <button
                      className="text-primary-600"
                      onClick={() => onOptionLeft(meal, option)}
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                  )}
                  <button
                    onClick={() => setCurrentTab(index)}
                    className={`whitespace-nowrap  px-2 py-4 h-full text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 `}
                  >
                    {index + 1}
                  </button>
                  {!readonly && currentTab === index && (
                    <Fragment>
                      <button
                        onClick={() => onOptionDelete(meal, option)}
                        className={`whitespace-nowrap px-2 py-4 h-full text-sm font-medium text-red-600 hover:text-red-900`}
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </button>
                      {counter > 0 && (
                        <button
                          onClick={() => onOptionSwap(meal, option)}
                          className={`whitespace-nowrap px-2 py-4 h-full text-sm font-medium`}
                        >
                          <FontAwesomeIcon icon={faArrowsRetweet} />
                        </button>
                      )}
                      <button
                        className="text-primary-600"
                        onClick={() => onOptionRight(meal, option)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </Fragment>
                  )}
                </div>
              ))}
          </nav>

          {objective != NutritionObjectives.Health && (
            <div
              className={`ml-auto h-14 flex items-center ${
                showSupplementation ? "border-b-2 border-primary text-primary-600" : ""
              }`}
            >
              <button onClick={onShowSuplementation} className="text-inherit">Suplementación</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
